import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Carousel from 'react-spring-3d-carousel';
import { config } from "react-spring";

import { popupChange } from '../../actions'
import CardBody from './cardBody.js'
import EmptyCardsGroupBody from './emptyCardsGroupCard.js';
import { cardsExist } from '../../functions/finder';
import CardsGroupInfo from './cardsGroupInfo.js';

class Card extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            goToSlide: 0,
            offsetRadius: 2,
            showNavigation: false,
            config: config.slow,
            isFirstTime: true
        };
    }
    
    handleClosePopup = () => {
        this.props.popupChange("none")
    };

    handleGoToSlide = (ind) => {
        let count = 0
        for (const id of Object.keys(this.props.popup.cardsGroup.cards)) {
            if (id === ind && count !== this.state.goToSlide) {
                this.setState({goToSlide: count})
            }
            count += 1
        }
    }

    render(){   

        let slides = []    
        let render = false
        let emptyCardsGroup = true
        if (this.props.popup !== "none") {
            render = true
            let initialSlide = 0
            const areCardsExist = cardsExist(this.props.popup.cardsGroup)
            const cardsData = areCardsExist ? this.props.popup.cardsGroup.cards : {}
            for (const [id, card] of Object.entries(cardsData)) {
                slides.push({
                    key: id,
                    content: <CardBody card={card} cardsGroup={this.props.popup.cardsGroup} rev={initialSlide}/>,
                    onClick: () => this.handleGoToSlide(id),
                })
                if (this.props.popup.card.id === card.id && this.state.isFirstTime) {
                    this.setState({goToSlide: initialSlide, isFirstTime: false})
                }
                initialSlide += 1
                emptyCardsGroup = false
            }
        } else {
            if (!this.state.isFirstTime) { this.setState({isFirstTime: true}) }
        }
        
        // Necessary for bug when less than two cards does not show carousel
        slides.push({
            key: 0,
            content: <div></div>})

        return (
            <div>
                {render && 
                    <div>
                        <div class="sensitive-background" onClick={() => this.handleClosePopup()}></div>
                            { emptyCardsGroup? (
                                <EmptyCardsGroupBody 
                                    cardsGroup={this.props.popup.cardsGroup}/>
                            ):(
                                <div>
                                    <CardsGroupInfo cardsGroup={this.props.popup.cardsGroup}/>
                                    <Carousel  
                                        slides={slides}
                                        goToSlide={this.state.goToSlide}
                                        offsetRadius={this.state.offsetRadius}
                                        showNavigation={this.state.showNavigation}
                                        animationConfig={this.state.config}
                                        infinite={false}
                                    />
                                </div>
                            ) }
                    </div>
                }
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popup : state.popup,
        day : state.day
    }
}

function matchDispatchToProps( dispatch ){
  return bindActionCreators({ 
      popupChange : popupChange
    }, dispatch)
}


export default connect(mapStateToProps, matchDispatchToProps)(Card)